import { useTranslation } from 'react-i18next';

export const PlaceholderTab = () => {
    const { t } = useTranslation();
    return (
        <div className={'flex h-full items-center justify-center p-8'}>
            <div className={'text-center'}>
                <p className={'text-obj-gray'}>{t('performanceProfile.comingSoon')}</p>
            </div>
        </div>
    );
};
